export const CUSTOM = {
  SELECT_DEALER: 'CUSTOM_SELECT_DEALER',
  SET_ACTIVE_FOOTER_TAB: 'CUSTOM_SET_ACTIVE_FOOTER_TAB',
  SET_ACTIVE_SUMMARY_TAB: 'CUSTOM_SET_ACTIVE_SUMMARY_TAB',
  SET_SEATING_FILTER: 'CUSTOM_SET_SEATING_FILTER',
  SET_MODEL_FILTER: 'CUSTOM_SET_MODEL_FILTER'
}